import { STEPS } from "../@interfaces/tabs.interface";
import { CALCULATOR_MODE } from "../@types/travel";
import { airports } from "./iataPorts";
import { airportsClasses, motorbikeTypes, motorbikeVehicleTypes, publicTransportTypes, vehicleSizes, vehicleTypes } from "./tabsConfig";

const calculateCarDirections = async (
  carDestinationFrom: string,
  carDestinationTo: string
) => {
  let directionsService = new window.google.maps.DirectionsService();
  let directionsRenderer = new window.google.maps.DirectionsRenderer();

  const route = {
    origin: carDestinationFrom,
    destination: carDestinationTo,
    travelMode: "DRIVING",
  };

  let directionsData: any = null;

  await directionsService.route(route as any, function (response, status) {
    if (status !== "OK") {
      console.log("Directions request failed due to " + status);
      return;
    }

    directionsRenderer.setDirections(response); // Add route to the map
    directionsData = (response as any)?.routes[0].legs[0];

    if (!directionsData) {
      console.log("Directions request failed");
    }
  });

  return directionsData;
};

const findFieldInConfig = (field: string, configArray: { name: string, value: string | null, label: string }[]) => {
  if (!field || !configArray) {
    return;
  }

  return configArray?.find(el => el?.value?.toLowerCase() === field?.toLowerCase());
};

const isAirportValid = (code: string) => airports.find(a => a?.code === code);

const handleUrlParameters = (
  urlParams: { [key: string]: string },
  setCustomValue: (id: string, value: any) => void,
  setCalculatorMode: (mode: string) => void) => {

  if (!urlParams || !setCalculatorMode) {
    return;
  }

  if (urlParams?.transportType === STEPS.FLIGHT) {
    if (urlParams?.origin) {
      isAirportValid(urlParams.origin) && setCustomValue('flights.origin', urlParams.origin);
    }

    if (urlParams?.destination) {
      isAirportValid(urlParams.destination) && setCustomValue('flights.destination', urlParams.destination);
    }

    if (urlParams?.passengers) {
      setCustomValue('flights.passengers', +urlParams.passengers);
    }

    if (urlParams?.cabinClass) {
      const value = findFieldInConfig(urlParams?.cabinClass, airportsClasses);
      value && setCustomValue('flights.cabinClass', value);
    }

    if (urlParams?.mode in CALCULATOR_MODE) {
      setCalculatorMode(urlParams?.mode);
    }
  }

  if (urlParams?.transportType === STEPS.PUBLIC_TRANSPORT) {
    if (urlParams?.origin) {
      setCustomValue('publicTransport.origin', urlParams?.origin);
    }

    if (urlParams?.destination) {
      setCustomValue('publicTransport.destination', urlParams?.destination);
    }

    if (urlParams?.publicTransportType) {
      const value = findFieldInConfig(urlParams?.publicTransportType, publicTransportTypes);
      value && setCustomValue('publicTransport.transportType', value);
    }
  }

  if (urlParams?.transportType === STEPS.MOTORBIKE) {
    if (urlParams?.origin) {
      setCustomValue('motorbike.origin', urlParams?.origin);
    }

    if (urlParams?.destination) {
      setCustomValue('motorbike.destination', urlParams?.destination);
    }

    if (urlParams?.motorbikeType) {
      const value = findFieldInConfig(urlParams?.motorbikeType, motorbikeTypes);
      value && setCustomValue('motorbike.motorbikeType', value);
    }

    if (urlParams?.vehicleType) {
      const value = findFieldInConfig(urlParams?.vehicleType, motorbikeVehicleTypes);
      value && setCustomValue('motorbike.vehicleType', value);
    }
  }

  if (urlParams?.transportType === STEPS.CAR) {
    if (urlParams?.origin) {
      setCustomValue('car.origin', urlParams?.origin);
    }

    if (urlParams?.destination) {
      setCustomValue('car.destination', urlParams?.destination);
    }

    if (urlParams?.vehicleSize) {
      const value = findFieldInConfig(urlParams?.vehicleSize, vehicleSizes);
      value && setCustomValue('car.vehicleSize', value);
    }

    if (urlParams?.vehicleType) {
      const value = findFieldInConfig(urlParams?.vehicleType, vehicleTypes);
      value && setCustomValue('car.vehicleType', value);
    }
  }
}

const getFullAirportName = (code: string) => {
  const airport = airports.find(a => a?.code === code);
  if (airport) {
    return `${airport?.code}, ${airport?.port}`
  }
}

export {
  calculateCarDirections,
  findFieldInConfig,
  handleUrlParameters,
  getFullAirportName,
  isAirportValid,
};
